import { Injectable } from '@angular/core';
import { SuggestionId } from '@models/suggestion-id.type';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { DossierState, DossierStateModel } from '@stores/dossier/dossier.state';
import {
  EligibleSuggestionClear,
  EligibleSuggestionsSet,
} from '@stores/eligible-suggestion/eligible-suggestion.action';

export interface EligibleSuggestionStateModel {
  suggestionIds: SuggestionId[];
  totalReward: number;
}

export const EligibleSuggestionStateToken = new StateToken<EligibleSuggestionStateModel>('eligibleSuggestions');

@State({
  name: EligibleSuggestionStateToken,
  defaults: null,
})
@Injectable()
export class EligibleSuggestionState {
  @Selector([EligibleSuggestionState, DossierState])
  static notPurchased(
    eligibleSuggestionState: EligibleSuggestionStateModel,
    dossierState: DossierStateModel
  ): SuggestionId[] {
    return eligibleSuggestionState?.suggestionIds?.filter(
      (suggestionId) => !dossierState?.map((dossier) => dossier.suggestionId).includes(suggestionId)
    );
  }

  @Selector([EligibleSuggestionStateToken])
  static totalReward(state: EligibleSuggestionStateModel): number {
    return state?.totalReward;
  }

  @Selector([EligibleSuggestionStateToken])
  static loaded(state: EligibleSuggestionStateModel): boolean {
    return !!state;
  }

  @Action(EligibleSuggestionsSet)
  eligibleSuggestionSet(ctx: StateContext<EligibleSuggestionStateModel>, action: EligibleSuggestionsSet) {
    ctx.setState(action.newEligibleSuggestionState);
  }

  @Action(EligibleSuggestionClear)
  eligibleSuggestionClear(ctx: StateContext<EligibleSuggestionStateModel>) {
    ctx.setState(null);
  }
}
